import React from 'react';

const PagePrivacyPolicy = () => {
    return (
        <div class="container">
            <h1>Privacy Policy</h1>

            <p>Welcome to our Privacy Policy page! When you use our web services, you trust us with your information. This Privacy Policy is meant to help you understand what data we collect, why we collect it, and what we do with it. This is important; we hope you will take time to read it carefully.</p>

            <h2>1. Information We Collect</h2>
            <p>We collect information to provide better services to our users. The information we collect includes:</p>
            <ul>
                <li>Usage data (pages visited, duration on page, etc.)</li>
            </ul>

            <h2>2. How We Use Information</h2>
            <p>We use the information we collect in various ways, including to:</p>
            <ul>
                <li>Provide, operate, and maintain our website</li>
                <li>Improve, personalize, and expand our website</li>
                <li>Understand and analyze how you use our website</li>
                <li>Develop new products, services, features, and functionality</li>
                <li>Communicate with you, either directly or through one of our partners, including for customer service, to provide you with updates and other information relating to the website, and for marketing and promotional purposes</li>
                <li>Process your transactions and manage your orders</li>
                <li>Find and prevent fraud</li>
            </ul>

            <h2>3. Information Sharing</h2>
            <p>We do not share your personal information with companies, organizations, or individuals outside of our organization except in the following cases:</p>
            <ul>
                <li>With your consent</li>
                <li>For external processing (we provide information to our affiliates or other trusted businesses to process it for us, based on our instructions and in compliance with our Privacy Policy and any other appropriate confidentiality and security measures)</li>
                <li>For legal reasons (we will share personal information with companies, organizations, or individuals outside of our organization if we have a good-faith belief that access, use, preservation, or disclosure of the information is reasonably necessary to meet any applicable law, regulation, legal process, or enforceable governmental request)</li>
            </ul>

            <h2>4. Data Security</h2>
            <p>We are committed to ensuring the security of your information. We use various security measures, including encryption and authentication tools, to help protect your information.</p>

            <h2>5. Your Data Protection Rights</h2>
            <p>We would like to make sure you are fully aware of all of your data protection rights. Every user is entitled to the following:</p>
            <ul>
                <li>The right to access – You have the right to request copies of your personal data.</li>
                <li>The right to rectification – You have the right to request that we correct any information you believe is inaccurate or complete information you believe is incomplete.</li>
                <li>The right to erasure – You have the right to request that we erase your personal data, under certain conditions.</li>
                <li>The right to restrict processing – You have the right to request that we restrict the processing of your personal data, under certain conditions.</li>
                <li>The right to object to processing – You have the right to object to our processing of your personal data, under certain conditions.</li>
                <li>The right to data portability – You have the right to request that we transfer the data that we have collected to another organization, or directly to you, under certain conditions.</li>
            </ul>

            <h2>6. Changes to This Privacy Policy</h2>
            <p>We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page. We encourage you to review this Privacy Policy periodically for any changes.</p>

        </div>
    );
};

export default PagePrivacyPolicy;